import {Pageable} from './pageable';
import {SORT_TYPE} from '../utils/enums/sort-type';

export interface FilterParam {
    filteringField: string,
    filteringValue: string | number
}

export interface Sortable {
    sortType: SORT_TYPE,
    sortColumn: string
}


export interface SearchCriteriaI {
    pageable: Pageable,
    sortBy: Sortable,
    filters: FilterParam[]
}

export class SearchCriteria implements SearchCriteriaI {
    filters: FilterParam[] = [];
    pageable: Pageable = new Pageable();
    sortBy: Sortable;

    public addFilter(fieldName: string, value: string | number) {
        this.filters.push({filteringField: fieldName, filteringValue: value});
    }

    public flushAll(): void {
        this.flushSort();
        this.flushFilters();
    }

    public flushSort(): void {
        this.sortBy = null;
    }

    public flushFilters(): void {
        this.filters = [];
    }

    public applySort(sortColumn: string, sortType: SORT_TYPE): void {
        this.sortBy = {sortColumn, sortType};
    }

    public setPages(pages: number): void {
        this.pageable.pages = pages;
    }

}